import {ProgressSpinner} from 'primereact/progressspinner'

function Spinner({ props }) {
  return (
    <div className='flex justify-content-center align-items-center h-full'>
      <ProgressSpinner   {...props}/>
    </div>
  )
}

Spinner.defaultProps = {
  
}

export default Spinner